import { alpha } from "@mui/material/styles";
import AVCTheme from "../AVCThemeConfig";

export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        variant: "contained",
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          boxShadow: "none",
          "&::before": {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
          },
          "&:hover": {
            backgroundColor: theme.palette[ownerState.color].main,
            boxShadow: "none",
            color: `${theme.palette.primary.contrastText} !important`,
          },
          "&:focus": {
            boxShadow: `0px 0px 0px 4px ${alpha(theme.palette[ownerState.color].main, 0.25)} !important`,
          },
          "&:disabled": {
            backgroundColor: alpha(theme.palette[ownerState.color].main, 0.5),
            pointerEvents: "none",
          },
        }),

        outlined: {
          // border: `1px solid ${theme?.palette?.primary?.main} !important`,
        },

        sizeSmall: {
          fontSize: `${AVCTheme.fontSize.sm}`,
          padding: `${AVCTheme.padding.p2} ${AVCTheme.padding.p3}`,
          borderRadius: `${AVCTheme.borderRadius.sm}`,
          fontWeight: `${AVCTheme.fontWeight.normal}`,
        },
        sizeMedium: {
          fontSize: `${AVCTheme.fontSize.md}`,
          padding: `${AVCTheme.padding.p3} ${AVCTheme.padding.p4}`,
          borderRadius: `${AVCTheme.borderRadius.md}`,
          fontWeight: `${AVCTheme.fontWeight.regular}`,
        },
        sizeLarge: {
          fontSize: `${AVCTheme.fontSize.lg}`,
          padding: `${AVCTheme.padding.p4} ${AVCTheme.padding.p5}`,
          borderRadius: `${AVCTheme.borderRadius.lg}`,
          fontWeight: `${AVCTheme.fontWeight.bold}`,
        },
      },
    },
  };
}
